import ReactGA from "react-ga4";

export const initGA = (trackingID: string) => {
  ReactGA.initialize(trackingID);
};

export const logPageView = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: "Page view",
  });
  // ReactGA.set({ page: window.location.pathname });
  // ReactGA.pageview(window.location.pathname);
};

export const handleTestButtonClick = () => {
  ReactGA.event({
    category: "Click",
    action: "Test IS",
    label: "IS check",
  });
};

export const handleSoundToggleClick = () => {
  ReactGA.event({
    category: "Click",
    action: "Toggle sound status",
    label: "Sound update",
  });
};

export const handleAlertToggleClick = () => {
  ReactGA.event({
    category: "Click",
    action: "Toggle alert status",
    label: "Alert update",
  });
};

// export const handleTestButtonClick = () => {
//   window.gtag("event", "click", {
//     event_category: "User Interaction",
//     event_label: "Test internet button",
//   });
// };

// export const handleToggleSoundButtonClick = () => {
//   window.gtag("event", "click", {
//     event_category: "User Interaction",
//     event_label: "Sound update toggle",
//   });
// };
